/* Tech Mate product cards (snippets/tm-card.liquid):
   - hovering / focusing / tapping a colour swatch shows that colour's image and selects that colour
   - "Lägg i varukorg" (shown over the price on hover) and the "+" add the variant in the selected colour
   - on a model collection (/collections/iphone-18-pro-max) the matching model variant is used; a product that fits
     several models on a page without a model gets "Välj modell" (opens the product page with the colour preselected)
   The add-to-cart is done by the [data-tm-add] handler below (the same handler also lives in
   sections/tm-main-collection.liquid; the window.__tmCardAdd flag makes sure only one of them runs). */
(function () {
  if (window.__tmCardBuy) return;
  window.__tmCardBuy = true;

  // "For iPhone 18 Pro / 17 Pro" → ["iphone-18-pro", "iphone-17-pro"] (same rules as the device: tags)
  const slugs = (value) =>
    String(value || '')
      .replace(/^for\s+/i, '')
      .replace(/\(.*?\)/g, '')
      .split('/')
      .map((part) => {
        let x = part.trim();
        if (!x) return '';
        if (!/iphone/i.test(x)) x = 'iPhone ' + x;
        return x.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').replace('iphone-17-air', 'iphone-air');
      })
      .filter(Boolean);

  const pageModel = (() => {
    const m = window.location.pathname.match(/\/collections\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]).toLowerCase() : '';
  })();

  const dataOf = (card) => {
    if (!card._tmData) {
      try {
        card._tmData = JSON.parse(card.querySelector('[data-tm-card-variants]').textContent);
      } catch (e) {
        card._tmData = { ci: -1, mi: -1, v: [] };
      }
    }
    return card._tmData;
  };

  // Which variant would the buttons add right now?
  const pick = (card) => {
    const d = dataOf(card);
    const color = card.querySelector('.tm-card__swatch.is-active')?.dataset.tmColor || null;
    let list = d.v.filter((v) => v.a);
    if (d.ci >= 0 && color) list = list.filter((v) => v.o[d.ci] === color);
    if (d.mi >= 0 && new Set(d.v.map((v) => v.o[d.mi])).size > 1) {
      // Product pages (sections/tm-related.liquid) pass the model of the product being viewed.
      const model = card.closest('[data-tm-page-model]')?.dataset.tmPageModel || pageModel;
      const forPage = list.filter((v) => slugs(v.o[d.mi]).includes(model));
      if (!forPage.length) return { state: list.length ? 'choose' : 'out', variant: list[0] || null };
      list = forPage;
    }
    return list.length ? { state: 'add', variant: list[0] } : { state: 'out', variant: null };
  };

  const sync = (card) => {
    if (!card || !card.querySelector('[data-tm-buy]')) return;
    const r = pick(card);
    card.querySelectorAll('[data-tm-buy]').forEach((b) => {
      b.dataset.state = r.state;
      if (r.state === 'add') b.dataset.tmAdd = r.variant.id;
      else b.removeAttribute('data-tm-add');
      b.toggleAttribute('disabled', r.state === 'out');
      b.dataset.href = (card.dataset.url || '#') + (r.variant ? `?variant=${r.variant.id}` : '');
      const label = b.querySelector('[data-tm-buy-label]');
      if (label) label.textContent = label.dataset[r.state] || label.dataset.add;
      if (b.dataset.ariaBase) b.setAttribute('aria-label', `${label ? label.textContent : ''} – ${b.dataset.ariaBase}`);
    });
  };

  // Colour swatches: show that colour's image while the pointer / focus is on the card.
  const show = (sw) => {
    const card = sw.closest('.tm-card');
    if (!card) return;
    card.querySelectorAll('.tm-card__swatch.is-active').forEach((s) => s.classList.remove('is-active'));
    sw.classList.add('is-active');
    const img = card.querySelector('.tm-card__img:not(.tm-card__img--2)');
    if (img && sw.dataset.tmSwSrc) {
      if (!img.dataset.tmOrigSrc) {
        img.dataset.tmOrigSrc = img.getAttribute('src') || '';
        img.dataset.tmOrigSrcset = img.getAttribute('srcset') || '';
      }
      img.setAttribute('srcset', sw.dataset.tmSwSrcset || '');
      img.setAttribute('src', sw.dataset.tmSwSrc);
      img.loading = 'eager';
      card.classList.add('is-swatching');
    }
    sync(card);
  };
  const reset = (card) => {
    card.querySelectorAll('.tm-card__swatch.is-active').forEach((s) => s.classList.remove('is-active'));
    card.classList.remove('is-swatching');
    const img = card.querySelector('.tm-card__img:not(.tm-card__img--2)');
    if (img && img.dataset.tmOrigSrc) {
      img.setAttribute('srcset', img.dataset.tmOrigSrcset);
      img.setAttribute('src', img.dataset.tmOrigSrc);
    }
    sync(card);
  };

  document.addEventListener('mouseover', (e) => {
    const sw = e.target.closest && e.target.closest('.tm-card__swatch');
    if (sw) return show(sw);
    const card = e.target.closest && e.target.closest('.tm-card');
    if (card && !card._tmSynced) {
      card._tmSynced = true;
      sync(card);
    }
  });
  document.addEventListener('focusin', (e) => {
    const sw = e.target.closest && e.target.closest('.tm-card__swatch');
    if (sw) return show(sw);
    const card = e.target.closest && e.target.closest('.tm-card');
    if (card) sync(card);
  });
  // Keep the chosen colour while the pointer is on the card; back to the main image when it leaves the card.
  document.addEventListener('mouseout', (e) => {
    const card = e.target.closest && e.target.closest('.tm-card');
    if (!card || (e.relatedTarget && card.contains(e.relatedTarget))) return;
    if (card.querySelector('.tm-card__swatch.is-active')) reset(card);
  });
  // Touch: make sure the buttons are up to date before the tap's click event.
  document.addEventListener('pointerdown', (e) => {
    const card = e.target.closest && e.target.closest('.tm-card');
    if (card) sync(card);
  });
  document.addEventListener('click', (e) => {
    const sw = e.target.closest && e.target.closest('.tm-card__swatch');
    if (sw) {
      // A tap / click on a swatch selects the colour instead of opening the product page.
      e.preventDefault();
      return show(sw);
    }
    const b = e.target.closest && e.target.closest('[data-tm-buy]');
    if (b && b.dataset.state === 'choose') {
      e.preventDefault();
      window.location.href = b.dataset.href;
    }
  });
})();

(function () {
  // Add to cart for the card buttons and open the cart drawer (pages without tm-main-collection, e.g. product pages).
  if (window.__tmCardAdd) return;
  window.__tmCardAdd = true;
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-tm-add]');
    if (!btn) return;
    e.preventDefault();
    btn.classList.add('is-loading');
    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const body = { items: [{ id: Number(btn.dataset.tmAdd), quantity: 1 }] };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map((s) => s.id);
      body.sections_url = window.location.pathname;
    }
    try {
      const res = await fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || 'Error');
      if (cart && typeof cart.renderContents === 'function' && data.sections) {
        cart.classList.remove('is-empty');
        data.id = body.items[0].id;
        cart.renderContents(data);
      } else {
        window.location.href = window.routes.cart_url;
      }
    } catch (err) {
      alert(err.message);
    } finally {
      btn.classList.remove('is-loading');
    }
  });
})();
